import { get, keys, values } from 'lodash'
import { createSelector } from 'reselect'

export const getAttendants = (state) => values(get(state, 'staff.byId'))

const getAttendant = (state, staffId) => get(state, `staff.byId.${staffId}`, {})

export const makeGetAttendant = () => createSelector([getAttendant], (attendant) => attendant)

export const getFormRegisteredFields = (state) => keys(get(state, 'form.attendant-settings.registeredFields'))
export const getEventFormRegisteredFields = (state) => keys(get(state, 'form.attendant-event-settings.registeredFields'))

export const getToggles = (state) => get(state, 'staff.toggle', {})

export const getSearchSuitesStaffValue = (state) => state?.staff?.searchSuitesStaffValue ?? ''

export const getFilterAttendantStatus= (state) => state?.staff?.attendantStatusFilterValue ?? ''

export const getSuitesStaffIsLoading = (state) => state?.staff?.isLoading ?? false
